// Dependencies
import { graphql, useStaticQuery } from 'gatsby';

const useFeaturedAwards = () => {
  const { awards } = useStaticQuery(graphql`
    query FeaturedAwards {
      awards: allWpAward(sort: { menuOrder: ASC }) {
        nodes {
          id
          menuOrder
          featuredImage {
            node {
              altText
              gatsbyImage(width: 100, placeholder: NONE)
              localFile {
                publicURL
              }
              mediaDisplayOptions {
                filter
              }
            }
          }
        }
      }
    }
  `);

  // TO-DO: Fix reordering plugin
  // menuOrder 0 currently comes through to GQL as null and therefore the first post comes through as last without this additional logic
  const nodes = awards?.nodes;

  const newNodes = nodes.filter((node) => node?.menuOrder !== null);

  const nullOrder = nodes.filter((node) => node?.menuOrder == null);

  if (nullOrder.length) newNodes.unshift(nullOrder.pop());

  return newNodes;
};

export default useFeaturedAwards;
